import { useState } from 'react'
import './Settings.css'

function Settings() {
  const [activeTab, setActiveTab] = useState('profile')
  const [profileData, setProfileData] = useState({
    firstName: 'Sarah',
    lastName: 'Chen',
    email: 'sarah.chen@acmecorp.com',
    phone: '+1 (555) 123-4567',
    company: 'Acme Corp',
    timezone: 'America/New_York'
  })
  
  const [notifications, setNotifications] = useState({
    emailPayments: true,
    emailTeam: true,
    emailBilling: true,
    emailUpdates: false,
    pushPayments: true,
    pushTeam: false,
    pushAlerts: true
  })
  
  const [twoFactorEnabled, setTwoFactorEnabled] = useState(false)

  const tabs = [
    { id: 'profile', name: 'Profile', icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
        <circle cx="12" cy="7" r="4"/>
      </svg>
    )},
    { id: 'security', name: 'Security', icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
        <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
      </svg>
    )},
    { id: 'notifications', name: 'Notifications', icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
        <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
      </svg>
    )},
    { id: 'api', name: 'API Keys', icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"/>
      </svg>
    )}
  ]

  const apiKeys = [
    { id: 1, name: 'Production API Key', prefix: 'pk_live_...3f9d', created: 'Jan 15, 2024', lastUsed: '2 hours ago', status: 'active' },
    { id: 2, name: 'Test API Key', prefix: 'pk_test_...8a2e', created: 'Jan 10, 2024', lastUsed: 'Never', status: 'active' }
  ]

  return (
    <div className="settings-page">
      {/* Header */}
      <div className="page-header">
        <h1 className="page-title">Settings</h1>
        <p className="page-subtitle">Manage your account preferences and security settings</p>
      </div>

      <div className="settings-layout">
        {/* Tabs */}
        <nav className="settings-tabs">
          {tabs.map(tab => (
            <button
              key={tab.id}
              className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.icon}
              {tab.name}
            </button>
          ))}
        </nav>

        {/* Content */}
        <div className="settings-content">
          {/* Profile Tab */}
          {activeTab === 'profile' && (
            <div className="settings-section">
              <div className="section-header">
                <h2 className="section-title">Profile Information</h2>
                <p className="section-desc">Update your personal details and preferences</p>
              </div>

              <div className="profile-avatar-section">
                <div className="avatar-large">
                  <span>SC</span>
                </div>
                <div className="avatar-actions">
                  <button className="btn btn-secondary btn-sm">Change photo</button>
                  <button className="btn btn-ghost btn-sm">Remove</button>
                </div>
              </div>

              <form className="settings-form">
                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label">First name</label>
                    <input 
                      type="text" 
                      className="form-input"
                      value={profileData.firstName}
                      onChange={(e) => setProfileData({...profileData, firstName: e.target.value})}
                    />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Last name</label>
                    <input 
                      type="text" 
                      className="form-input"
                      value={profileData.lastName}
                      onChange={(e) => setProfileData({...profileData, lastName: e.target.value})}
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label className="form-label">Email address</label>
                  <input 
                    type="email" 
                    className="form-input"
                    value={profileData.email}
                    onChange={(e) => setProfileData({...profileData, email: e.target.value})}
                  />
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label">Phone number</label>
                    <input 
                      type="tel" 
                      className="form-input"
                      value={profileData.phone}
                      onChange={(e) => setProfileData({...profileData, phone: e.target.value})}
                    />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Company</label>
                    <input 
                      type="text" 
                      className="form-input"
                      value={profileData.company}
                      onChange={(e) => setProfileData({...profileData, company: e.target.value})}
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label className="form-label">Timezone</label>
                  <select 
                    className="form-input"
                    value={profileData.timezone}
                    onChange={(e) => setProfileData({...profileData, timezone: e.target.value})}
                  >
                    <option value="America/New_York">Eastern Time (US & Canada)</option>
                    <option value="America/Chicago">Central Time (US & Canada)</option>
                    <option value="America/Denver">Mountain Time (US & Canada)</option>
                    <option value="America/Los_Angeles">Pacific Time (US & Canada)</option>
                    <option value="Europe/London">London</option>
                    <option value="Europe/Paris">Paris</option>
                    <option value="Asia/Tokyo">Tokyo</option>
                  </select>
                </div>

                <div className="form-actions">
                  <button type="submit" className="btn btn-primary">Save changes</button>
                </div>
              </form>
            </div>
          )}

          {/* Security Tab */}
          {activeTab === 'security' && (
            <div className="settings-section">
              <div className="section-header">
                <h2 className="section-title">Security Settings</h2>
                <p className="section-desc">Protect your account with additional security measures</p>
              </div>

              {/* Password */}
              <div className="security-card">
                <div className="security-info">
                  <div className="security-icon">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                      <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                    </svg>
                  </div>
                  <div>
                    <h3 className="security-title">Password</h3>
                    <p className="security-desc">Last changed 3 months ago</p>
                  </div>
                </div>
                <button className="btn btn-secondary">Change password</button>
              </div>

              {/* 2FA */}
              <div className="security-card">
                <div className="security-info">
                  <div className={`security-icon ${twoFactorEnabled ? 'enabled' : ''}`}>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                    </svg>
                  </div>
                  <div>
                    <h3 className="security-title">Two-factor authentication</h3>
                    <p className="security-desc">
                      {twoFactorEnabled 
                        ? 'Your account is protected with 2FA'
                        : 'Add an extra layer of security to your account'
                      }
                    </p>
                  </div>
                </div>
                <label className="toggle">
                  <input 
                    type="checkbox" 
                    checked={twoFactorEnabled}
                    onChange={(e) => setTwoFactorEnabled(e.target.checked)}
                  />
                  <span className="toggle-slider"></span>
                </label>
              </div>

              {/* Sessions */}
              <div className="security-card">
                <div className="security-info">
                  <div className="security-icon">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/>
                      <line x1="8" y1="21" x2="16" y2="21"/>
                      <line x1="12" y1="17" x2="12" y2="21"/>
                    </svg>
                  </div>
                  <div>
                    <h3 className="security-title">Active sessions</h3>
                    <p className="security-desc">3 devices currently logged in</p>
                  </div>
                </div>
                <button className="btn btn-secondary">Manage sessions</button>
              </div>

              {/* Danger Zone */}
              <div className="danger-section">
                <h3 className="danger-title">Danger Zone</h3>
                <div className="danger-card">
                  <div>
                    <h4 className="danger-action-title">Delete account</h4>
                    <p className="danger-desc">Permanently remove your account and all associated data</p>
                  </div>
                  <button className="btn btn-danger">Delete account</button>
                </div>
              </div>
            </div>
          )}

          {/* Notifications Tab */}
          {activeTab === 'notifications' && (
            <div className="settings-section">
              <div className="section-header">
                <h2 className="section-title">Notification Preferences</h2>
                <p className="section-desc">Choose how you want to be notified about activity</p>
              </div>

              <div className="notification-group">
                <h3 className="notification-group-title">Email notifications</h3>
                <div className="notification-list">
                  <label className="notification-item">
                    <div className="notification-info">
                      <span className="notification-name">Payment updates</span>
                      <span className="notification-desc">Receive emails about successful and failed payments</span>
                    </div>
                    <label className="toggle">
                      <input 
                        type="checkbox" 
                        checked={notifications.emailPayments}
                        onChange={(e) => setNotifications({...notifications, emailPayments: e.target.checked})}
                      />
                      <span className="toggle-slider"></span>
                    </label>
                  </label>
                  <label className="notification-item">
                    <div className="notification-info">
                      <span className="notification-name">Team activity</span>
                      <span className="notification-desc">Get notified when team members join or change roles</span>
                    </div>
                    <label className="toggle">
                      <input 
                        type="checkbox" 
                        checked={notifications.emailTeam}
                        onChange={(e) => setNotifications({...notifications, emailTeam: e.target.checked})}
                      />
                      <span className="toggle-slider"></span>
                    </label>
                  </label>
                  <label className="notification-item">
                    <div className="notification-info">
                      <span className="notification-name">Billing alerts</span>
                      <span className="notification-desc">Invoice reminders and usage alerts</span>
                    </div>
                    <label className="toggle">
                      <input 
                        type="checkbox" 
                        checked={notifications.emailBilling}
                        onChange={(e) => setNotifications({...notifications, emailBilling: e.target.checked})}
                      />
                      <span className="toggle-slider"></span>
                    </label>
                  </label>
                  <label className="notification-item">
                    <div className="notification-info">
                      <span className="notification-name">Product updates</span>
                      <span className="notification-desc">News about new features and improvements</span>
                    </div>
                    <label className="toggle">
                      <input 
                        type="checkbox" 
                        checked={notifications.emailUpdates}
                        onChange={(e) => setNotifications({...notifications, emailUpdates: e.target.checked})}
                      />
                      <span className="toggle-slider"></span>
                    </label>
                  </label>
                </div>
              </div>

              <div className="notification-group">
                <h3 className="notification-group-title">Push notifications</h3>
                <div className="notification-list">
                  <label className="notification-item">
                    <div className="notification-info">
                      <span className="notification-name">Payment alerts</span>
                      <span className="notification-desc">Real-time notifications for large payments</span>
                    </div>
                    <label className="toggle">
                      <input 
                        type="checkbox" 
                        checked={notifications.pushPayments}
                        onChange={(e) => setNotifications({...notifications, pushPayments: e.target.checked})}
                      />
                      <span className="toggle-slider"></span>
                    </label>
                  </label>
                  <label className="notification-item">
                    <div className="notification-info">
                      <span className="notification-name">Team mentions</span>
                      <span className="notification-desc">Get notified when you're mentioned</span>
                    </div>
                    <label className="toggle">
                      <input 
                        type="checkbox" 
                        checked={notifications.pushTeam}
                        onChange={(e) => setNotifications({...notifications, pushTeam: e.target.checked})}
                      />
                      <span className="toggle-slider"></span>
                    </label>
                  </label>
                  <label className="notification-item">
                    <div className="notification-info">
                      <span className="notification-name">System alerts</span>
                      <span className="notification-desc">Critical alerts and security notifications</span>
                    </div>
                    <label className="toggle">
                      <input 
                        type="checkbox" 
                        checked={notifications.pushAlerts}
                        onChange={(e) => setNotifications({...notifications, pushAlerts: e.target.checked})}
                      />
                      <span className="toggle-slider"></span>
                    </label>
                  </label>
                </div>
              </div>
            </div>
          )}

          {/* API Keys Tab */}
          {activeTab === 'api' && (
            <div className="settings-section">
              <div className="section-header">
                <h2 className="section-title">API Keys</h2>
                <p className="section-desc">Manage your API keys for integration and development</p>
              </div>

              <div className="api-warning">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="10"/>
                  <line x1="12" y1="8" x2="12" y2="12"/>
                  <line x1="12" y1="16" x2="12.01" y2="16"/>
                </svg>
                <p>Keep your API keys secure. Never share them publicly or commit them to version control.</p>
              </div>

              <div className="api-keys-list">
                {apiKeys.map(key => (
                  <div key={key.id} className="api-key-card">
                    <div className="api-key-info">
                      <div className="api-key-header">
                        <span className="api-key-name">{key.name}</span>
                        <span className={`api-key-status ${key.status}`}>{key.status}</span>
                      </div>
                      <div className="api-key-value">
                        <code>{key.prefix}</code>
                        <button className="btn-icon" title="Copy key">
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <rect x="9" y="9" width="13" height="13" rx="2" ry="2"/>
                            <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>
                          </svg>
                        </button>
                      </div>
                      <div className="api-key-meta">
                        <span>Created {key.created}</span>
                        <span>·</span>
                        <span>Last used {key.lastUsed}</span>
                      </div>
                    </div>
                    <div className="api-key-actions">
                      <button className="btn btn-ghost btn-sm">Regenerate</button>
                      <button className="btn btn-danger-ghost btn-sm">Revoke</button>
                    </div>
                  </div>
                ))}
              </div>

              <button className="btn btn-secondary">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <line x1="12" y1="5" x2="12" y2="19"/>
                  <line x1="5" y1="12" x2="19" y2="12"/>
                </svg>
                Create new API key
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default Settings
